import {
  QS_IDS,
  QUESTION_SET_OVERRIDES,
} from "@/constants/questionset.constants";
import { qsMapping } from "@/qs/mapping";

const getQsMetadata = (questionSetId, callChannel) => {
  // Get most specific (i.e. D2C) first
  const qsWithChannelMetadata = QS_IDS.find(
    (q) => q.id === questionSetId && q.callChannel === callChannel
  );
  if (qsWithChannelMetadata) return qsWithChannelMetadata;

  const qsAnyMetadata = QS_IDS.find(
    (q) => q.id === questionSetId && q.callChannel === undefined
  );
  return qsAnyMetadata;
};

const getQsImportFunction = (journey, fileDir, stage) => {
  const productImports = qsMapping[journey];
  if (!productImports) return null;

  const channelsImports = productImports[fileDir];
  if (!channelsImports) return null;

  const stageImport = channelsImports[stage];
  return stageImport || null;
};

export const isQuilterSpecific = (questionSetId) => {
  const match = QS_IDS.find((q) => q.id === questionSetId);
  return match && match.brand === "quilter";
};

export const getProductId = (questionSetId) => {
  const match = QS_IDS.find((q) => q.id === questionSetId);
  return match?.productId;
};

export const getProductGroup = (questionSetId) => {
  const match = QS_IDS.find((q) => q.id === questionSetId);
  return match?.journey;
};

export const getIsRollingMonthly = (questionSetId) => {
  const match = QS_IDS.find((q) => q.id === questionSetId);

  return match?.isRollingMonthly ?? false;
};

const overrideTopLevelQuestions = (qsSection, override) => {
  let qsQuestionIndex = qsSection.Questions?.findIndex((q) => {
    return q.InterfaceKey === override.InterfaceKey;
  });
  if (qsQuestionIndex > -1) {
    qsSection.Questions[qsQuestionIndex] = override;
  }
};

const overrideSubQuestions = (questions, override) => {
  questions.forEach((questions) => {
    if (questions.Questions) {
      const subQuestionIndex = questions.Questions.findIndex((subQuestion) => {
        return subQuestion.InterfaceKey === override.InterfaceKey;
      });
      if (subQuestionIndex > -1) {
        questions.Questions[subQuestionIndex] = override;
      }
    }
  });
};

const applyOverride = (qsData, stage, override) => {
  if (stage === "questions") {
    qsData.Sections.filter((qsSection) => qsSection.Questions).forEach(
      (qsSection) => {
        overrideTopLevelQuestions(qsSection, override);
        overrideSubQuestions(qsSection.Questions, override);
      }
    );
  } else if (stage === "application") {
    qsData.Sections.filter((qsSection) => qsSection.SubSections).forEach(
      (qsSection) => {
        qsSection.SubSections.forEach((qsSubSection) => {
          if (qsSubSection.Questions) {
            overrideTopLevelQuestions(qsSubSection, override);
            overrideSubQuestions(qsSubSection.Questions, override);
          }
        });
      }
    );
  }
};

export const getQuestionSetData = async (
  questionSetId,
  branchNumber,
  callChannel,
  stage
) => {
  const qsMetadata = getQsMetadata(questionSetId, callChannel);
  if (qsMetadata === null) return null;

  const fileDirForStage = qsMetadata[stage];
  console.log(
    "QS",
    questionSetId,
    callChannel,
    "=",
    qsMetadata.journey,
    fileDirForStage,
    stage
  );

  const importFunction = getQsImportFunction(
    qsMetadata.journey,
    fileDirForStage,
    stage
  );
  console.log("Import -> ", importFunction);

  const fileResponse = await importFunction();
  const qsData = fileResponse.default;

  // Apply VC override to application stage when isVc
  if (qsMetadata.isVc && stage === "application") {
    const vcOverride = QUESTION_SET_OVERRIDES.find((override) => override.isVc);
    vcOverride.overrides.forEach((ov) => applyOverride(qsData, stage, ov));
  }

  // Apply other overrides (e.g. Advised)
  const matchedOverride = QUESTION_SET_OVERRIDES.find(
    (override) =>
      override.branchNumber === branchNumber ||
      override.callChannel === callChannel
  );

  if (!matchedOverride) return qsData;
  matchedOverride.overrides.forEach((ov) => applyOverride(qsData, stage, ov));

  return qsData;
};

export function findError(form) {
  const allErrors = {};

  const traverseComponents = (components) => {
    components.forEach((component) => {
      if (component.id && component.errorBucket) {
        if (!component.valid) {
          allErrors[component.id] = component.errorBucket;
        }
      }
    });
  };
  traverseComponents(form.inputs);
  return allErrors;
}
